import { useState } from 'react';
import VacancyList from './components/VacancyList';
import VacancyDetail from './components/VacancyDetail';
import NewVacancyModal from './components/NewVacancyModal';

export default function Vacancies() {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [showNew, setShowNew] = useState(false);
  // Меняется после создания вакансии — список перечитывает данные
  const [reloadKey, setReloadKey] = useState(0);

  const handleCreated = (id: string) => {
    setShowNew(false);
    setReloadKey((k) => k + 1);
    setSelectedId(id);
  };

  return (
    <div className="flex gap-0 min-h-[calc(100vh-120px)] -mx-6 md:-mx-8">
      {/* Left: Vacancy List */}
      <div className="w-[380px] shrink-0 border-r border-background-200 bg-background-50 overflow-y-auto">
        <div className="sticky top-0 bg-background-50 z-10 px-5 py-4 border-b border-background-200">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h2 className="text-lg font-heading font-semibold text-foreground-900">Вакансии</h2>
              <p className="text-xs text-foreground-500 mt-0.5">Выберите вакансию для просмотра</p>
            </div>
            <button
              onClick={() => setShowNew(true)}
              className="shrink-0 px-3 py-2 rounded-xl bg-primary-500 text-white text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer flex items-center gap-1.5"
            >
              <i className="ri-add-line" />
              Новая
            </button>
          </div>
        </div>
        <VacancyList key={reloadKey} selectedId={selectedId} onSelect={setSelectedId} />
      </div>

      {/* Right: Vacancy Detail */}
      <div className="flex-1 bg-white overflow-y-auto min-w-0">
        <VacancyDetail vacancyId={selectedId} />
      </div>

      {showNew && (
        <NewVacancyModal onClose={() => setShowNew(false)} onCreated={handleCreated} />
      )}
    </div>
  );
}
